import React, { useEffect, useRef } from 'react';
import './ImageSlider3D.css';

const ImageSlider3D = () => {
  const nextButtonRef = useRef(null);
  const prevButtonRef = useRef(null);
  const carouselRef = useRef(null);
  const listRef = useRef(null);
  const seeMoreButtonsRef = useRef([]);
  const backButtonRef = useRef(null);
  const autoSlideIntervalRef = useRef(null);
  // Removed isPausedRef

  useEffect(() => {
    const nextButton = nextButtonRef.current;
    const prevButton = prevButtonRef.current;
    const carousel = carouselRef.current;
    const listHTML = listRef.current;
    const seeMoreButtons = seeMoreButtonsRef.current;
    const backButton = backButtonRef.current;

    let unAcceptClick;

    const showSlider = (type) => {
      if (!nextButton || !prevButton || !carousel || !listHTML) return;

      nextButton.style.pointerEvents = 'none';
      prevButton.style.pointerEvents = 'none';

      carousel.classList.remove('next', 'prev');
      let items = carousel.querySelectorAll('.item');

      if (type === 'next') {
        listHTML.appendChild(items[0]);
        carousel.classList.add('next');
      } else {
        listHTML.prepend(items[items.length - 1]);
        carousel.classList.add('prev');
      }

      clearTimeout(unAcceptClick);
      unAcceptClick = setTimeout(() => {
        nextButton.style.pointerEvents = 'auto';
        prevButton.style.pointerEvents = 'auto';
      }, 2000);
    };

    const handleNext = () => showSlider('next');
    const handlePrev = () => showSlider('prev');

    const stopAutoSlide = () => {
      if (autoSlideIntervalRef.current) {
        clearInterval(autoSlideIntervalRef.current);
        autoSlideIntervalRef.current = null;
      }
    };

    const startAutoSlide = () => {
      stopAutoSlide();
      autoSlideIntervalRef.current = setInterval(() => {
        // Removed isPausedRef and showDetail condition
        handleNext();
      }, 4000);
    };

    const handleSeeMore = () => {
      if (!carousel) return;
      carousel.classList.remove('next', 'prev');
      carousel.classList.add('showDetail');
      /* Do not stop auto-slide anymore */
    };

    const handleBack = () => {
      if (!carousel) return;
      carousel.classList.remove('showDetail');
      /* No need to start auto-slide, it's always running */
    };

    // Removed mouseenter/mouseleave handlers
    if (nextButton) nextButton.onclick = handleNext;
    if (prevButton) prevButton.onclick = handlePrev;
    if (backButton) backButton.onclick = handleBack;

    seeMoreButtons.forEach((button) => {
      if (button) button.onclick = handleSeeMore;
    });

    // No mouseenter/mouseleave event listeners

    // Start auto-slide after a short delay to ensure DOM is ready
    const initTimer = setTimeout(() => {
      startAutoSlide();
    }, 100);

    return () => {
      clearTimeout(initTimer);
      if (nextButton) nextButton.onclick = null;
      if (prevButton) prevButton.onclick = null;
      if (backButton) backButton.onclick = null;
      seeMoreButtons.forEach((button) => {
        if (button) button.onclick = null;
      });
      // No mouse event cleanup needed
      stopAutoSlide();
    };
  }, []);

  const properties = [
    {
      id: 1,
      image: "/cut outs/villa 1.png",
      title: "VILLA 1",
      topic: "Modern Villa",
      description: "Luxury living with contemporary design.",
      detailTitle: "Villa 1 AMODA",
      detailDescription: "This magnificent villa offers unparalleled luxury with its contemporary design, premium finishes, and breathtaking views. Featuring spacious living areas, state-of-the-art amenities, and meticulous attention to detail throughout.",
      specifications: [
        { label: "Bedrooms", value: "4" },
        { label: "Bathrooms", value: "3" },
        { label: "Area", value: "2500 sq ft" },
        { label: "Parking", value: "2 Cars" },
        { label: "Garden", value: "Private" }
      ],
      gradientClass: "villa-gradient"
    },
    {
      id: 2,
      image: "/cut outs/Glamping-dome-6m-size-4.png",
      title: "GLAMPING DOME",
      topic: "Dome House",
      description: "Unique dome living blending nature and comfort.",
      detailTitle: "Glamping Dome AMODA",
      detailDescription: "This innovative dome structure offers a unique living experience. With its distinctive design and panoramic views, it provides a perfect blend of outdoor adventure and indoor comfort.",
      specifications: [
        { label: "Bedrooms", value: "2" },
        { label: "Bathrooms", value: "1" },
        { label: "Area", value: "600 sq ft" },
        { label: "Diameter", value: "6m" },
        { label: "View", value: "360° Panoramic" }
      ],
      gradientClass: "dome-gradient"
    },
    {
      id: 3,
      image: "/cut outs/Wholesale-40FT-Modern-Prefabricated-House-Space-Capsule-House-Mobile-Cabin-for-Resort.png",
      title: "SPACE CAPSULE",
      topic: "Capsule House",
      description: "Futuristic compact living with modern design.",
      detailTitle: "Space Capsule AMODA",
      detailDescription: "This modern prefabricated capsule house represents the future of compact living. Designed for efficiency and style, it offers a unique residential experience with all modern amenities.",
      specifications: [
        { label: "Bedrooms", value: "1" },
        { label: "Bathrooms", value: "1" },
        { label: "Area", value: "400 sq ft" },
        { label: "Length", value: "40 FT" },
        { label: "Type", value: "Mobile Cabin" }
      ],
      gradientClass: "capsule-gradient"
    },
    {
      id: 4,
      image: "/cut outs/delimitation-land-plots.png",
      title: "LAND PLOTS",
      topic: "Plot Delimitation",
      description: "Build your dream home on premium land.",
      detailTitle: "Land Plots AMODA",
      detailDescription: "Our thoughtfully designed land plots provide the ideal foundation for building your custom home. Each plot is carefully delimited and offers stunning views of the surrounding landscape.",
      specifications: [
        { label: "Plot Size", value: "Varies" },
        { label: "Location", value: "Premium" },
        { label: "Access", value: "Paved Road" },
        { label: "Utilities", value: "Available" },
        { label: "View", value: "Mountain" }
      ],
      gradientClass: "land-gradient"
    }
  ];

  return (
    <section className="image-slider-3d">
      <div className="container">
        <div className="slider-header">
          <h2 className="slider-title" style={{ color: 'rgba(0,0,0,0.7)' }}>
            Step Inside Your Future Home.
          </h2>
          <p className="slider-subtitle">Explore immersive walkthroughs of our signature spaces —<br />Domes, A-Frames, and Capsules.</p>
          <a
            className="seeMore"
            href="https://amoda-sari.spatium360.in/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Launch Experience
          </a>
        </div>

        <div className="carousel" ref={carouselRef}>
          <div className="list" ref={listRef}>
            {properties.map((property, index) => (
              <div key={property.id} className={`item ${property.gradientClass}`}>
                <img src={property.image} alt={property.topic} />
                <div className="introduce">
                  <div className="title">{property.title}</div>
                  <div className="topic">{property.topic}</div>
                  <div className="des">{property.description}</div>
                  {null}
                </div>
                <div className="detail">
                  <div className="title">{property.detailTitle}</div>
                  <div className="des">{property.detailDescription}</div>
                  <div className="specifications">
                    {property.specifications.map((spec, specIndex) => (
                      <div key={specIndex}>
                        <p>{spec.label}</p>
                        <p>{spec.value}</p>
                      </div>
                    ))}
                  </div>
                  <div className="checkout">
                    <button>SCHEDULE VISIT</button>
                    <button>GET QUOTE</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="arrows">
            <button id="prev" ref={prevButtonRef}>&lt;</button>
            <button id="next" ref={nextButtonRef}>&gt;</button>
            <button id="back" ref={backButtonRef}>See All &#8599</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImageSlider3D;